export default "__VITE_ASSET__CGcEofS$__"